import { Injectable, signal } from '@angular/core';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { AppUpdate, AppUpdateAvailability  } from '@capawesome/capacitor-app-update';

@Injectable({
  providedIn: 'root',
})
export class UpdateCheckService {
  private checking = false;
  private initialized = false;

  // signal público para mostrar el modal
  readonly updateAvailable = signal(false);

  async init(): Promise<void> {
    if (this.initialized) return;
    this.initialized = true;

    // Cuando la app vuelve al foreground: esperar a que la red se re-establezca
    App.addListener('appStateChange', ({ isActive }) => {
      if (isActive) setTimeout(() => void this.checkNow(), 3000);
    });

    // Chequeo inicial: diferido para no competir con el arranque de la app y la red
    setTimeout(() => void this.checkNow(), 5000);
  }

  async checkNow(retriesLeft = 2): Promise<void> {
    if (!Capacitor.isNativePlatform()) return;
    if (this.checking) return;

    this.checking = true;

    try {
      // country: en iOS el plugin consulta la iTunes Lookup API de esa tienda
      // puntual; sin especificarlo busca en la tienda de EE.UU. (default),
      // donde la app no está publicada, así que nunca detecta actualización.
      const info = await AppUpdate.getAppUpdateInfo({ country: 'ar' });

      /**
       * Android (Play Store):
       *  - updateAvailability === UPDATE_AVAILABLE
       * iOS:
       *  - consulta la iTunes Lookup API
       */
      const available = info.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE;

      this.updateAvailable.set(available);
    } catch (e) {
      console.warn('[UpdateCheck] No se pudo verificar actualización', e);

      // Reintentar si el check falló (red inestable o API lenta)
      if (retriesLeft > 0) {
        setTimeout(() => {
          this.checking = false;
          void this.checkNow(retriesLeft - 1);
        }, 5000);
        return;
      }
    } finally {
      this.checking = false;
    }
  }

  // Abrir Play Store / App Store
  async openStore(): Promise<void> {
    await AppUpdate.openAppStore({
      appId: '6749094445',
    });
  }

  // Cerrar modal (el usuario canceló)
  close(): void {
    this.updateAvailable.set(false);
  }
}
